import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Dataview } from '../../../dataQuest.constants';
import { DataViewService } from './dataview.service';
import { DetailsService } from '../details/details.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/shared/util.service';
import { checkDuplicateDisplayNameControl } from 'src/app/shared/Validators/checkDuplicateDisplayName';

@Component({
  selector: 'edit-dataview',
  templateUrl: './edit-dataview.component.html',
  styleUrls: ['./edit-dataview.component.scss']
})

export class EditDataviewComponent implements OnInit {

  viewId: any;
  addtagFlag: any = false;
  keyword = 'name';
  keywordAccessGroup = 'name';
  @ViewChild('auto') auto:any;
  @ViewChild('autoAccess') autoAccess:any;
  viewForm: FormGroup;
  viewFormCopy: FormGroup;
  autocompleteText:any="";
  tagsByViewId:any=[]
  successMessage: string = null;
  errorMessageSubmit: string = null;

  // Hardcoded data starts

  editDVHeaders: Array<any> = [ 'Field Name', 'Display Name', 'isFilter?'];
  

  item: Dataview | null = null;
  itemId: string | null = null;
  allTags: any = [];
  fieldsArray: any;
  reqFrom: any;
  tagList: any=[];
  searchText: any='';
  page: any=1;
  limit: any='';
  accessGroupList: any =[];
  allAccessGroups: any = [];
  addAccessGroupFlag: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private location: Location,
    private dataViewService: DataViewService,
    private detailsService: DetailsService,
    private spinner: NgxSpinnerService,
    private utilService: UtilService,
    private fb: FormBuilder,
    public dialog: MatDialog) {}
  
  ngOnInit(): void {
    this.viewId = this.route.snapshot.paramMap.get('id');
    this.reqFrom = history.state.reqFrom;
    //---------get Veiw Data using viewId-----
    this.getViewDataById();
    
  }


  getViewDataById() {
    this.spinner.show();
    this.dataViewService.getDataviewById(this.viewId).subscribe({
    next: (res: any) => {
      if (res.code === 400) {
        this.errorMessageSubmit = res?.result?.error || res?.message;          
        this.spinner.hide();
        setTimeout(() => {
          this.errorMessageSubmit = null;
          this.utilService.setManagedView(true); 
        //  this.router.navigate(['/admin-settings']);
        if(this.viewId && this.reqFrom ==='detailView'){
          this.router.navigate(['/details',this.viewId]); 
        }  else{
          this.router.navigate(['/admin-settings']);  
        } 
        }, 3000);
      } else {
        const response  = res.result;
        this.item = response;
        this.viewId = this.item.viewId;
        this.getAllTags();
        this.getAllAccessGroups();
        this.initForm();
        this.fieldsControls();                             
        this.errorMessageSubmit = null;        
        this.spinner.hide();                                
      }
    },
    error: (err: any) => {
      this.spinner.hide();      
      this.errorMessageSubmit = err || err?.result?.error; 
      this.spinner.hide();
      setTimeout(() => {
        this.errorMessageSubmit = null;
        this.utilService.setManagedView(true); 
      //  this.router.navigate(['/admin-settings']);
      if(this.viewId && this.reqFrom ==='detailView'){
        this.router.navigate(['/details',this.viewId]); 
      }  else{
        this.router.navigate(['/admin-settings']);  
      } 
      }, 3000);
      this.utilService.goToTop();
    }
   });
  }

  initForm() {
    
    this.viewForm = new FormGroup({
      userId: new FormControl(sessionStorage.getItem('userId')),
      viewId: new FormControl(this.item.viewId),      
      viewName: new FormControl(this.item.viewName),
      description: new FormControl(this.item.viewDescription),
      tags: new FormArray([]),
      accessGroups: new FormArray([]),
      fields: new FormArray([])
    });
    
    //------Fill Assigned Tags-----
    let index = 0;
    this.item.assignedTags.forEach( (assignedTag: any) =>{
      const fg =this.fb.group({
        tagId: new FormControl(assignedTag.id),
        tagName: new FormControl(assignedTag.tagName),
        status: new FormControl('Existing')
      });
      
      (<FormArray>this.viewForm.get('tags')).insert(index, fg);
      index++;
    })
  //------Fill Assigned Access Groups-----
    let indexItem = 0;
    this.item.assignedAccessGroups?.forEach( (assignedAccessGroup: any) =>{
      const fg =this.fb.group({
        accessGroupId: new FormControl(assignedAccessGroup.id),
        accessGroupName: new FormControl(assignedAccessGroup.access_group_name),
        isAssigned: new FormControl(true)
      });

      (<FormArray>this.viewForm.get('accessGroups')).insert(indexItem, fg);
      indexItem++;
    })
    //--------Fill View Fields------
    let fieldIndex = 0;
    this.item.viewFields.forEach((row: any) => {
      const fg =this.fb.group({
        fieldId: new FormControl(row.id),
        displayName: new FormControl(
          row.displayName,
          [Validators.required,checkDuplicateDisplayNameControl]),
        fieldName: new FormControl(row.fieldName),
        isFilter: new FormControl(row.isFilter),
        isHidden: new FormControl(false),        
      });

      (<FormArray>this.viewForm.get('fields')).insert(fieldIndex, fg);
      fieldIndex++;            
    });
  }


  fieldsControls(): any{
   this.fieldsArray = (<FormArray>this.viewForm.get('fields')).controls;
   return this.fieldsArray;
  }

  
  
  save() {
    let data = this.viewForm.value;
    console.log(data);
    this.spinner.show();

    this.dataViewService.saveView(data).subscribe({
      next: (res: any) => {
        if (res.code === 400) {
          this.errorMessageSubmit = res?.result?.message || res?.message;          
          this.spinner.hide();
          setTimeout(() => {
            this.errorMessageSubmit = null;
          }, 3000);
        } else {
          const savedraftres = res;                              
          this.errorMessageSubmit = null;
          this.successMessage = `${savedraftres.result}`;
          this.spinner.hide();
          this.utilService.goToTop();
          setTimeout(() => {
            this.successMessage = null;
            this.utilService.setManagedView(true); 
         //   this.router.navigate(['/admin-settings']);
         if(this.viewId && this.reqFrom ==='detailView'){
          this.router.navigate(['/details',this.viewId]); 
        }  else{
          this.router.navigate(['/admin-settings']);  
        } 
          }, 3000);
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        this.errorMessageSubmit =  err; 
        this.spinner.hide();
        setTimeout(() => {
          this.errorMessageSubmit = null;
        }, 3000);
        this.utilService.goToTop();
      },
      });
  }

  
  goBack() {
    if(this.viewForm.touched && !this.viewForm.pristine){
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          title: 'Confirmation',
          message: ' This action will clear all unsaved data. Do you want to proceed?'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result){ 
          this.utilService.setManagedView(true); 
        //  this.router.navigate(['/admin-settings']);
          if (this.viewId && this.reqFrom ==='detailView'){
            this.router.navigate(['/details',this.viewId]); 
          }  else{
            this.router.navigate(['/admin-settings']);  
          } 
        }                        
      });
    } else if(!this.viewForm.touched  || (this.viewForm.touched && this.viewForm.pristine)){
      this.utilService.setManagedView(true); 
    //  this.router.navigate(['/admin-settings']);
      if(this.viewId && this.reqFrom ==='detailView'){
        this.router.navigate(['/details',this.viewId]); 
      }  else{
        this.router.navigate(['/admin-settings']);  
      }    
   }
  }


  removeTag(assignedTag:any){
    let assignedTagsCopy = this.item.assignedTags;   
    this.item.assignedTags = [...assignedTagsCopy.filter( tag => {
          return tag.tagName != assignedTag.tagName;
    }) ]  

    this.removeTagForm(assignedTag);
  }
  removeAccessGroup(assignedGroup:any){
    let assignedGroupsCopy = this.item.assignedAccessGroups;
    this.item.assignedAccessGroups = [...assignedGroupsCopy.filter( group => {
          return group.access_group_name != assignedGroup.access_group_name;
    }) ];

    // Add back to allAccessGroups only if not already present
  if (!this.accessGroupList.some((group:any) => group.id === assignedGroup.id)) {
    this.accessGroupList.push({
      id: assignedGroup.id,
      name: assignedGroup.access_group_name || assignedGroup.name
    });
  }
    this.removeAccessGroupForm(assignedGroup);
  }
  removeTagForm(assignedTag: any) {
    const id = assignedTag.id;
    let formArray  = (<FormArray>this.viewForm.get('tags'));
  
    formArray.value.forEach((element: any) => {
      if(element.tagId == id && id != 0)
      {        
        let i = (<FormArray>this.viewForm.get('tags')).value.indexOf(element);
        if(element['status'] == 'Added')
        {
         
         this.removeTagFormControlWithValue(id);                               
        } else {      
          element['status'] = 'Removed';                    
          (<FormArray>this.viewForm.get('tags')).controls[i].setValue(element);
        }

      } else if(element.tagName == assignedTag.tagName && id == 0) {  
          this.removeTagFormControlWithValue(0);                                                                               
      }
    });      
  }
  removeAccessGroupForm(assignedGroup: any) {
    const id = assignedGroup.id;
    let formArray  = (<FormArray>this.viewForm.get('accessGroups'));

    formArray.value.forEach((element: any) => {
      if(element.accessGroupId == id && id != 0)
      {        
        let i = (<FormArray>this.viewForm.get('accessGroups')).value.indexOf(element);
        if(element['isAssigned'] == true)
        {

         this.removeAccessGroupFormControlWithValue(id);
        } else {
          element['isAssigned'] = false;
          (<FormArray>this.viewForm.get('accessGroups')).controls[i].setValue(element);
        }

      } else if(element.access_group_name == assignedGroup.access_group_name && id == 0) {
          this.removeAccessGroupFormControlWithValue(0);
      }
    });      
  }

  removeTagFormControlWithValue(id: any) {
    let k = 0;
      (<FormArray>this.viewForm.get('tags')).controls.forEach(el1 => {
          console.log(el1.value.tagId);
          if(el1.value.tagId == id){
            (<FormArray>this.viewForm.get('tags')).controls.splice(k, 1);
            (<FormArray>this.viewForm.get('tags')).value.splice(k, 1);
          } else {
            k = k+1;
          }
      });
  }
  removeAccessGroupFormControlWithValue(id: any) {
    let k = 0;
      (<FormArray>this.viewForm.get('accessGroups')).controls.forEach(el1 => {
          console.log(el1.value.accessGroupId);
            if(el1.value.accessGroupId == id){
            el1.get('isAssigned')?.setValue(false);
            } else {
            k = k+1;
          }
      });
  }
  getAllTags(){
    this.detailsService.getAllTags().subscribe(res=>{
      if(res){
        this.tagList=res.result.map((x:any)=>({id:x.id,name:x.tagName})).filter((md:any) => 
          this.item.assignedTags.every((fd:any) => fd.id !== md.id))
        if(this.autocompleteText&&this.autocompleteText!=='') this.allTags = [...this.tagList,{name: this.autocompleteText}]
        else this.allTags = [this.tagList];
      }
    })
  }
  getAllAccessGroups() {
    let userId = sessionStorage.getItem('userId')
    let payload = null
    payload = { "userId": userId, "searchText": this.searchText, "sortBy": '', "sortType": "" };
   
    this.dataViewService.getAllAccessGroups(payload, this.page, this.limit).subscribe(res=>{
        if(res){
          this.accessGroupList=res.result.map((x:any)=>({id:x.groupId,name:x.groupName})).filter((md:any) => 
            this.item.assignedAccessGroups?.every((fd:any) => fd.id !== md.id))
          if(this.autocompleteText&&this.autocompleteText!=='') this.allAccessGroups = [...this.accessGroupList,{name: this.autocompleteText}]
          else this.allAccessGroups = [this.accessGroupList];
      }
    })
  }
  showAddInput(){
    this.addtagFlag=true;
  }
  showAddInputForAccessGroup(){
      this.addAccessGroupFlag=true;
  }
  addNewTag(e:any, flag=false){    
    if(flag){
      this.addTags(e,true)
    }else{
      this.addTags(e.target.value,true)
    }
  } 
  addNewAccessGroup(e:any, flag=false){    
    if(flag){
      this.addAccessGroup(e,true)
    }else{
      this.addAccessGroup(e.target.value,true)
    }
  } 
   addAccessGroup(item:any,addNew=false){
    const tag = addNew ? item : item.name;
    const id = addNew ? 0 : item.id;
    let accessGroupObj;
     let tagNames: any[] = this.item.assignedAccessGroups?.map(assignedAccessGroup => 
       assignedAccessGroup.accessGroupName.toUpperCase()
    );

    if(!tagNames.includes(tag.toUpperCase())){
      if(id == 0){
        accessGroupObj = { accessGroupName: tag};
      } else {
         accessGroupObj = {id: id, accessGroupName: tag};
      }
      this.item.assignedAccessGroups?.push(accessGroupObj);
      this.autocompleteText="";
      this.addAccessGroupFlag = false;
      this.addAccessGroupForm(accessGroupObj, true);    
    }
  }

  addTags(item:any,addNew=false){
    const tag = addNew ? item : item.name;
    const id = addNew ? 0 : item.id;
    let tagObj;
     let tagNames: any[] = this.item.assignedTags.map(assignedTag => 
       assignedTag.tagName.toUpperCase()
    );

    if(!tagNames.includes(tag.toUpperCase())){
      if(id == 0){
        tagObj = { tagName: tag};
      } else {
         tagObj = {id: id, tagName: tag};
      }
      this.item.assignedTags.push(tagObj);
      this.autocompleteText="";
      this.addtagFlag = false;
      this.addTagForm(tagObj, 'Added');    
    }
  }
addAccessGroups(item:any,addNew=false){
    const tag = addNew ? item : item.name;
    const id = addNew ? 0 : item.id;
    let accessGroupObj;
     let accessGroupNames: any[] = this.item.assignedAccessGroups?.map(assignedAccessGroup => 
       assignedAccessGroup.access_group_name.toUpperCase()
    );

    if(!accessGroupNames.includes(tag.toUpperCase())){
      if(id == 0){
        accessGroupObj = { access_group_name: tag};
      } else {
         accessGroupObj = {id: id, access_group_name: tag};
      }
      this.item.assignedAccessGroups.push(accessGroupObj);
      this.autocompleteText="";
      this.addAccessGroupFlag = false;
      this.addAccessGroupForm(accessGroupObj, true);    
    }
  }

  addTagForm(item: any, action: any) {
    const fg =this.fb.group({
      tagId: new FormControl(item.id),
      tagName: new FormControl(item.tagName),
      status: new FormControl(action)
    });
    
    let formArray = (<FormArray>this.viewForm.get('tags'));
    formArray.push(fg);
  }
  addAccessGroupForm(item: any, action: any) {
    let formArray = (<FormArray>this.viewForm.get('accessGroups'));
    let found = false;

    // Check if already present
    formArray.controls.forEach(control => {
      if (
        control.get('accessGroupId')?.value === item.id ||
        control.get('accessGroupName')?.value === item.access_group_name
      ) {
        // If present, update isAssigned flag
        control.get('isAssigned')?.setValue(action);
        found = true;
      }
    });

    // If not present, add new
    if (!found) {
      const fg = this.fb.group({
        accessGroupId: new FormControl(item.id),
        accessGroupName: new FormControl(item.access_group_name),
        isAssigned: new FormControl(action)
      });
      formArray.push(fg);
    }
  }
  getTagsByView() {
    this.addtagFlag = false;
    if (!this.viewId) {
      this.detailsService.viewId.subscribe(res => {
        this.viewId = res.viewId;
        this.detailsService.getTagsByView(this.viewId).subscribe(res => {
          if (res) {
            this.tagsByViewId = res.result       
            this.item.assignedTags = [...this.tagsByViewId];             
            this.autocompleteText="";
          }
          this.getAllTags()
        })
      })
    } else {
      this.detailsService.getTagsByView(this.viewId).subscribe(res => {
        if (res) {
          this.tagsByViewId = res.result
          this.item.assignedTags = [...this.tagsByViewId]; 
          this.autocompleteText="";
        }
        this.getAllTags()
      })
    }
  }

  selectEvent(item: any) {
    if(!item.id){
      let tagNames: any[] = this.tagList?.map((exsitingTag:any) => 
        exsitingTag.name.toUpperCase()
     );
      if(!tagNames.includes(item.name.toUpperCase())){
        this.addNewTag(item.name,true)
      }
    }else{
      this.addTags(item);
    }
  }
  setText(e:any){
    this.autocompleteText=e.target.value;
    if(this.autocompleteText&&this.autocompleteText!=='') this.allTags = [...this.tagList,{name: this.autocompleteText }]
    else this.allTags = [this.tagList]
  }
 selectEventForAccessGroup(item: any) {
    if(!item.id){
      let accessGroupNames: any[] = this.accessGroupList?.map((exsitingTag:any) => 
        exsitingTag.name.toUpperCase()
     );
      if(!accessGroupNames.includes(item.name.toUpperCase())){
        this.addNewAccessGroup(item.name,true)
      }
    }else{
      this.addAccessGroups(item);
    }
  }
  setTextForAccessGroup(e:any){
    this.autocompleteText=e.target.value;
    if(this.autocompleteText&&this.autocompleteText!=='') this.allAccessGroups = [...this.accessGroupList,{name: this.autocompleteText }]
    else this.allAccessGroups = [this.accessGroupList]
  }
  reset(){
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: 'Confirmation',
        message: ' This action will clear all the records.Are you sure you want to cancel?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result){        
        this.getViewDataById();   
      }                        
    });
  }

  isValid(){
    return this.fieldsArray.every((group: any) => {
      return (
        (group.valid)
      );
    });
  }
}
